/**
 * CK | Recently Viewed — Liquid-rendered product cards.
 *
 * Replaces theme.RecentlyViewed's JS-built cards with full Liquid-rendered
 * product-grid-item cards (badges, quick shop, custom swatches, etc.).
 *
 * Used by sections/recently-viewed.liquid (data-section-type="ck-recently-viewed").
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'theme-recent';
  var VIEW_NO_WL = 'ck-recently-viewed-item';
  var VIEW_WL = 'ck-recently-viewed-item-wl';
  var SIZE_CLASS_RE = /^(small|medium-up)--one-/;

  function CkRecentlyViewed(container) {
    this.container = container;
    this.sectionId = container.getAttribute('data-section-id');
    this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
    this.currentHandle = container.getAttribute('data-product-handle') || '';
    this.recentCount = parseInt(container.getAttribute('data-recent-count'), 10) || 5;
    this.gridItemClass = container.getAttribute('data-grid-item-class') || '';
    this.view = container.getAttribute('data-wishlist-enable') === 'true' ? VIEW_WL : VIEW_NO_WL;
    this._stylesInjected = false;

    if (!this.outputContainer) return;

    // Defer load until the section is near the viewport (matches theme's 600px threshold)
    var self = this;
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.disconnect();
        self.load();
      });
    }, { rootMargin: '600px' });

    observer.observe(container);
  }

  CkRecentlyViewed.prototype.load = function () {
    var handles = this.getHandles();

    if (!handles.length) {
      this.container.classList.add('hide');
      return;
    }

    var self = this;
    var promises = handles.map(function (handle) {
      return self.fetchCard(handle);
    });

    Promise.all(promises).then(function (htmlItems) {
      var rendered = 0;

      htmlItems.forEach(function (html) {
        if (!html) return;

        var item = self.parseItem(html);
        if (!item) return;

        self.outputContainer.appendChild(item);
        rendered++;
      });

      if (rendered === 0) {
        self.container.classList.add('hide');
        return;
      }

      // Let the wishlist mark the hearts of the newly injected cards.
      document.dispatchEvent(new CustomEvent('ck:cards:loaded'));

      // Re-run initQuickShop so newly injected .grid-product elements get
      // their mouseover listener — initQuickShop binds directly (not delegated).
      if (window.theme && typeof theme.initQuickShop === 'function') {
        theme.initQuickShop();
      }

      // Hoist newly injected quick shop modals to <body> so position:fixed
      // works correctly inside the overflow:scroll grid-overflow-wrapper on mobile.
      if (typeof window.ckHoistModals === 'function') {
        window.ckHoistModals();
      }

      if (window.AOS) AOS.refreshHard();
    });
  };

  CkRecentlyViewed.prototype.getHandles = function () {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return [];

      var recent = JSON.parse(stored);
      var currentHandle = this.currentHandle;
      var limit = this.recentCount;

      return Object.keys(recent)
        .reverse()
        .filter(function (h) { return h && h !== 'undefined' && h !== currentHandle; })
        .slice(0, limit);
    } catch (e) {
      return [];
    }
  };

  CkRecentlyViewed.prototype.fetchCard = function (handle) {
    var root = (window.theme && window.theme.routes && window.theme.routes.home) || '';
    var url = (root + '/products/' + handle + '?view=' + this.view).replace('//', '/');
    return fetch(url)
      .then(function (res) {
        if (!res.ok) return null;
        return res.text();
      })
      .catch(function () { return null; });
  };

  CkRecentlyViewed.prototype.parseItem = function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');

    // Inject any <style> tags from the snippet (e.g. carousel styles from product-grid-item)
    // into the main document once — they won't exist in the DOM since we use layout none.
    if (!this._stylesInjected) {
      this._stylesInjected = true;
      var styles = doc.querySelectorAll('style');
      styles.forEach(function (style) {
        var existing = document.querySelector('[data-ck-rv-style]');
        if (existing) return;
        var tag = document.createElement('style');
        tag.setAttribute('data-ck-rv-style', '');
        tag.textContent = style.textContent;
        document.head.appendChild(tag);
      });
    }

    var item = doc.querySelector('.grid__item');
    if (!item) return null;

    this.replaceGridClass(item);
    return item;
  };

  CkRecentlyViewed.prototype.replaceGridClass = function (item) {
    if (!this.gridItemClass) return;

    var toRemove = [];
    item.classList.forEach(function (cls) {
      if (SIZE_CLASS_RE.test(cls)) toRemove.push(cls);
    });
    toRemove.forEach(function (cls) { item.classList.remove(cls); });

    this.gridItemClass.split(' ').forEach(function (cls) {
      if (cls) item.classList.add(cls);
    });
  };

  // Bootstrap
  function init() {
    document.querySelectorAll('[data-section-type="ck-recently-viewed"]').forEach(function (container) {
      if (container.dataset.ckRvInit) return;
      container.dataset.ckRvInit = '1';
      new CkRecentlyViewed(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
